const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const parseEmailList = (value) => [...new Set(
  value
    .split(/[,\n;\r]+/)
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean)
)];

export const parseCsvEmails = (value) => {
  const rows = [];
  let row = [];
  let field = '';
  let quoted = false;
  const csv = value.replace(/^\uFEFF/, '');

  for (let index = 0; index < csv.length; index += 1) {
    const character = csv[index];
    if (character === '"') {
      if (quoted && csv[index + 1] === '"') {
        field += '"';
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (!quoted && character === ',') {
      row.push(field);
      field = '';
    } else if (!quoted && (character === '\n' || character === '\r')) {
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
      if (character === '\r' && csv[index + 1] === '\n') index += 1;
    } else {
      field += character;
    }
  }

  if (quoted) throw new Error('Malformed CSV');
  if (field || row.length) {
    row.push(field);
    rows.push(row);
  }

  const cells = rows.flat();
  const hasEmailHeader = cells.some((cell) => /^(e-?mail|email address)$/i.test(cell.trim()));
  const candidateCells = hasEmailHeader
    ? rows.slice(1).flat()
    : cells;

  return parseEmailList(candidateCells.filter((cell) => cell.includes('@')).join('\n'));
};

export const findInvalidEmails = (emails) => emails.filter((email) => !emailPattern.test(email));
